import $ from 'jquery'

window.jQuery = window.$ = $;

// Import all of Bootstrap's JS
import * as bootstrap from 'bootstrap'

window.bootstrap = bootstrap;

// import simplebar
import simplebar from 'simplebar';

// import dropzone
import dropzone from 'dropzone';

// コンポーネントのパスを@componentsに修正
import { initFlatPicker } from '@components/ui/flatpicker';
import { initOffcanvas } from '@components/ui/offcanvas';
import { initPopover } from '@components/ui/popover';
import { initToast } from '@components/ui/toast';
import { initTooltip } from '@components/ui/tooltip';


// グローバルに公開
window.initFlatPicker = initFlatPicker;
window.initOffcanvas = initOffcanvas;
window.initPopover = initPopover;
window.initToast = initToast;
window.initTooltip = initTooltip;
window.initComponents = (elem) => {
    initFlatPicker(elem);
    initOffcanvas(elem);
    initPopover(elem);
    initToast(elem);
    initTooltip(elem);
}  

